const config = {
    apiBaseUrl: 'https://company-cleanup-api.access-lp.com'
};

export { config };
